import React, { useState, useEffect } from 'react'
// import { FiChevronDown } from "react-icons/fi";
import { MdMenu } from "react-icons/md";
import { IoMdClose } from "react-icons/io";
// import { IoIosHelpBuoy } from "react-icons/io";
// import { IoMdConstruct } from "react-icons/io";
// import { PiTelevisionBold } from "react-icons/pi";
// import { FaHouseTsunami } from "react-icons/fa6";
// import { MdEnergySavingsLeaf } from "react-icons/md";
// import { BsTelephoneOutbound } from "react-icons/bs";
// import { GiReceiveMoney } from "react-icons/gi";
// import { RiMoneyDollarBoxLine } from "react-icons/ri";
// import { FaOilCan } from "react-icons/fa";
import { Link } from 'react-router-dom';
import lawberonLogo from "../../images/logo/lawberonlogo.jpeg";
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram } from 'react-icons/fa';

const Navbar = () => {
  // const [showSectorsDropdown, setShowSectorsDropdown] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [navbarFixed, setNavbarFixed] = useState(false);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Practice Areas', path: '/services' },
    // { name: 'Services', path: '/services' },
    { name: 'Insights', path: '/insights' },
    { name: 'About us', path: '/about' },
    { name: 'Contact', path: '/contact' },
    { name: 'Industries', path: '/industries' },
  ];

  // const sectorsDropdownItems = [
  //   { name: "FMCG", path: "/sectors/fmcg", icon: <IoIosHelpBuoy /> },
  //   { name: "Construction", path: "/sectors/construction", icon: <IoMdConstruct /> },
  //   { name: "Media & Entertainment", path: "/sectors/media-&-entertainment", icon: <PiTelevisionBold /> },
  //   { name: "Real Estate", path: "/sectors/real-estate", icon: <FaHouseTsunami /> },
  //   { name: "Energy & Nat Rates", path: "/sectors/energy-&-natural-resources", icon: <MdEnergySavingsLeaf /> },
  //   { name: "Telecom", path: "/sectors/telecommunications", icon: <BsTelephoneOutbound /> },
  //   { name: "Insurance", path: "/sectors/insurance", icon: <GiReceiveMoney /> },
  //   { name: "Financial Institutions", path: "/sectors/financial-institutions", icon: <RiMoneyDollarBoxLine /> },
  //   { name: "Oil & Gas", path: "/sectors/oil-&-gas", icon: <FaOilCan /> },
  // ];

  useEffect(() => {
    const handleScroll = () => {
      setNavbarFixed(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="top-0 sticky z-50 w-full">
      <div className={`border-b-[1px] border-[#00000032] py-4 workSans px-8 gap-4 md:flex justify-end items-center hidden relative ${navbarFixed ? "bg-[#052137] text-white" : "bg-white text-black"}`}>
        <div className="flex space-x-4">
          <a href="/" target='_blank' className="text-gray-400 hover:text-red-500">
            <FaFacebookF />
          </a>
          <a href="/" target='_blank' className="text-gray-400 hover:text-red-500">
            <FaTwitter />
          </a>
          <a href="/" target='_blank' className="text-gray-400 hover:text-red-500">
            <FaLinkedinIn />
          </a>
          <a href="/" target='_blank' className="text-gray-400 hover:text-red-500">
            <FaInstagram />
          </a>
        </div>
        <a href="mailto:info@lawberonlegals.com" target="_blank" rel="noreferrer">info@lawberonlegals.com</a>
        <p>|</p>
        <a href="tel:+2349025525239">+234-9025525239</a>
      </div>
      <nav
        className={`transition-all duration-300 py-4 workSans px-8 flex justify-between items-center relative ${navbarFixed ? "bg-[#052137] text-white fixed w-full top-0 left-0 shadow-lg" : "bg-white text-black"
          }`}
      >
        {/* Logo */}
        <div className="flex items-center space-x-2">
          <a href="/"><img src={lawberonLogo} alt="Company Logo" className="w-10" /></a>
        </div>
        {/* Hamburger Menu */}
        <div className="lg:hidden">
          <button onClick={() => setMenuOpen(!menuOpen)}>
            {menuOpen ? <IoMdClose size={24} /> : <MdMenu size={24} />}
          </button>
        </div>
        {/* Desktop Nav Links */}
        <ul className={`lg:flex space-x-8 items-center ${navbarFixed ? "text-white" : "text-gray-800"} hidden`}>
          {navLinks.map((link, index) => (
            <li key={index} className="hover:text-gray-600">
              <Link to={link.path}>{link.name}</Link>
            </li>
          ))}
          {/* Dropdown: Sectors */}
          {/* <li
            className="relative group cursor-pointer"
            onMouseEnter={() => setShowSectorsDropdown(true)}
            onMouseLeave={() => setShowSectorsDropdown(false)}
          >
            <Link to="/sectors">
              <div className="flex items-center hover:text-gray-600">
                Industries <FiChevronDown size={16} className="ml-1" />
              </div>
            </Link>
            {showSectorsDropdown && (
              <ul className="absolute left-0 bg-white z-10 text-gray-800 border shadow-md w-[500px] grid grid-cols-2 sm:grid-cols-3 gap-4 p-2">
                {sectorsDropdownItems.map((item, index) => (
                  <Link to={item.path}>
                    <div key={index} className="px-4 py-2 flex gap-4 items-center hover:bg-gray-100">
                      <p>{item.icon}</p>
                      <p>{item.name}</p>
                    </div>
                  </Link>
                ))}
              </ul>
            )}
          </li> */}
        </ul>
        {/* Mobile Menu */}
        {menuOpen && (
          <ul className="absolute top-full left-0 w-full bg-white shadow-lg flex flex-col text-gray-800 lg:hidden">
            {navLinks.map((link, index) => (
              <li key={index} onClick={() => setMenuOpen(!menuOpen)} className="px-4 py-2 hover:bg-gray-100">
                <Link to={link.path}>{link.name}</Link>
              </li>
            ))}
            {/* Dropdown: Sectors */}
            {/* <li className="relative group cursor-pointer px-4 py-2 hover:bg-gray-100">
              <div className="flex justify-between items-center" onClick={() => setShowSectorsDropdown(!showSectorsDropdown)}>
                Sectors <FiChevronDown size={16} className="ml-1" />
              </div>
              {showSectorsDropdown && (
                <ul className="bg-white text-gray-800 z-10 border shadow-md">
                  {sectorsDropdownItems.map((item, index) => (
                    <li key={index} onClick={() => setMenuOpen(!menuOpen)} className="px-4 py-2 hover:bg-gray-100">
                      <Link to={item.path}>{item.name}</Link>
                    </li>
                  ))}
                </ul>
              )}
            </li> */}
            <div className="p-4">
              <Link to="/book" onClick={() => setMenuOpen(!menuOpen)} className="bg-[#052137] text-white px-6 py-2 rounded-md font-semibold block lg:hidden">
                SPEAK WITH A CONSULTANT &#8594;
              </Link>
            </div>
          </ul>
        )}
        {/* Button */}
        <Link to="/book" className={`${navbarFixed ? "bg-[#fff] text-[#052137]" : "bg-[#052137] text-white"} px-6 py-2 rounded-md font-semibold hidden lg:block`}>
          SPEAK WITH A CONSULTANT &#8594;
        </Link>
      </nav>
    </div>
  );
}

export default Navbar;
